import { useParams } from 'react-router-dom'
import {
  useProjectDetailQuery,
  type GetProjectDetailsParams,
} from './useProjectDetailQuery'
import { ProjectDetail } from './ProjectDetail'
import { Spinner } from '~/shadcn/ui/spinner'

function ProjectDetailPage() {
  const { businessId, stageNumber } = useParams<GetProjectDetailsParams>()
  const { data: project, isFetching } = useProjectDetailQuery({
    businessId: businessId!,
    stageNumber: stageNumber!,
  })

  if (isFetching || project == null) {
    return <Spinner className="size-6" />
  }

  return <ProjectDetail project={project} />
}

export default ProjectDetailPage
